import Loader2 from 'lucide-react/dist/esm/icons/loader-2'
import LogOut from 'lucide-react/dist/esm/icons/log-out'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/dialog'

interface LogoutConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoggingOut?: boolean
}

/** Confirmation dialog shown before signing the user out. */
export function LogoutConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoggingOut = false,
}: LogoutConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!isLoggingOut) {
          onOpenChange(nextOpen)
        }
      }}
    >
      <DialogContent className="gap-0 overflow-hidden p-0 sm:max-w-[360px]">
        <div className="flex flex-col items-center px-6 pb-2 pt-8 text-center">
          <div
            className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10"
            aria-hidden="true"
          >
            <LogOut className="h-5 w-5 text-primary" strokeWidth={2} />
          </div>

          <DialogTitle className="text-lg font-semibold tracking-tight">
            Are you sure you want to log out?
          </DialogTitle>
          <DialogDescription className="mt-2 max-w-[17rem] text-sm leading-relaxed">
            You&apos;ll need to sign in again to continue.
          </DialogDescription>
        </div>

        <DialogFooter className="mt-4 gap-3 border-t border-border/40 px-6 py-5 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            className="h-11 flex-1 rounded-xl"
            disabled={isLoggingOut}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="h-11 flex-1 rounded-xl"
            disabled={isLoggingOut}
            onClick={onConfirm}
          >
            {isLoggingOut ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Logging out…
              </>
            ) : (
              'Log out'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
